import { Instance, applySnapshot, flow, getParent, types } from 'mobx-state-tree';

import {
	deleteAcademicProduct,
	getAcademicProduct,
	updateAcademicProduct,
} from '@common/api/academicProducts';

const AcademicProduct = types
	.model('AcademicProduct', {
		id: types.identifierNumber,
		name: types.optional(types.string, ''),
		programCount: types.optional(types.number, 0),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views(() => ({}))
	.actions((self) => ({
		fetch: flow(function* () {
			self.loading = true;
			try {
				const result = yield getAcademicProduct(self.id);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
		remove: flow(function* () {
			self.loading = true;
			try {
				yield deleteAcademicProduct(self.id);
				const parent: any = getParent(self, 2);
				parent.removeItem(self);
			} catch (e) {
				self.loading = false;
			}
		}),
		save: flow(function* (data: any) {
			self.loading = true;
			try {
				const result = yield updateAcademicProduct(self.id, data);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
	}));

export default AcademicProduct;

export interface IAcademicProductModel extends Instance<typeof AcademicProduct> {}
